export default __webpack_public_path__ + "static/media/linkedin-icon.f24aab41.svg";